import {PromoCode} from '@domain/model/Order/PromoCode';
import {PromoRepository, ValidatePromoCodeProps} from '@domain/model/Order/PromoRepository';
import {PromoCodeApplication} from '@application/PromoCode';

const ApplyPromoCode =
  (promoRepository: PromoRepository) =>
  async ({promocode, device, service}: ValidatePromoCodeProps): Promise<PromoCode | void> => {
    try {
      const promo = await promoRepository.applyPromoCode({promocode, device, service});
      PromoCodeApplication.setBoxRequestPromoCode(promocode);
      return promo;
    } catch {
      PromoCodeApplication.clearBoxRequestPromoCode();
    }
  };

export {ApplyPromoCode};
